"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var TooltipTextSC_1 = __importDefault(require("./styles/TooltipTextSC"));
var factoryTooltip_1 = __importDefault(require("./utils/factoryTooltip"));
var TooltipText = function (props) {
    var title = props.title, forwardedRef = props.forwardedRef, rootStyle = props.rootStyle, placement = props.placement, arrowProps = props.arrowProps, classNameProp = props.className;
    return (react_1.default.createElement(TooltipTextSC_1.default, { ref: forwardedRef, style: rootStyle, "data-placement": placement, className: clsx_1.default('_ndsTooltip', classNameProp) },
        react_1.default.createElement("div", { className: "_ndsTooltip__content" }, title),
        react_1.default.createElement("div", { ref: arrowProps.ref, style: arrowProps.style, className: "_ndsTooltip__arrow" })));
};
exports.default = factoryTooltip_1.default(TooltipText, 'text');
//# sourceMappingURL=TooltipText.js.map